module.exports = __webpack_public_path__ + "img/115.2810f520.png";